module.exports =  {
"US-AL"
    : 4447100
,
"US-AK"
    : 626932
,
"US-AZ"
    : 5130632
,
"US-AR"
    : 2673400
,
"US-CA"
    : 33871648
,
"US-CO"
    : 4301261
,
"US-CT"
    : 3405565
,
"US-DE"
    : 783600
,
"US-FL"
    : 15982378
,
"US-GA"
    : 8186453
,
"US-HI"
    : 1211537
,
"US-ID"
    : 1293953
,
"US-IL"
    : 12419293
,
"US-IN"
    : 6080485
,
"US-IA"
    : 2926324
,
"US-KS"
    : 2688418
,
"US-KY"
    : 4041769
,
"US-LA"
    : 4468976
,
"US-ME"
    : 1274923
,
"US-MD"
    : 5296486
,
"US-MA"
    : 6349097
,
"US-MI"
    : 9938444
,
"US-MN"
    : 4919479
,
"US-MS"
    : 2844658
,
"US-MO"
    : 5595211
,
"US-MT"
    : 902195
,
"US-NE"
    : 1711263
,
"US-NV"
    : 1998257
,
"US-NH"
    : 1235786
,
"US-NJ"
    : 8414350
,
"US-NM"
    : 1819046
,
"US-NY"
    : 18976457
,
"US-NC"
    : 8049313
,
"US-ND"
    : 642200
,
"US-OH"
    : 11353140
,
"US-OK"
    : 3450654
,
"US-OR"
    : 3421399
,
"US-PA"
    : 12281054
,
"US-RI"
    : 1048319
,
"US-SC"
    : 4012012
,
"US-SD"
    : 754844
,
"US-TN"
    : 5689283
,
"US-TX"
    : 20851820
,
"US-UT"
    : 2233169
,
"US-VT"
    : 608827
,
"US-VA"
    : 7078515
,
"US-WA"
    : 5894121
,
"US-WV"
    : 1808344
,
"US-WI"
    : 5363675
,
"US-WY"
    : 493782
  } 


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/areas.js